
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component<QuantitySelector>({})
export default class QuantitySelector extends Vue {
	@Prop({ type: String, required: true, default: '' }) private id!: string;
	@Prop({ type: Number, required: true, default: 0 }) private quantity!: number;
	@Prop({ type: Number, required: false }) private maxQuantity!: number;
	@Prop({ type: Boolean, required: false, default: false }) private disableDecrement!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private disableIncrement!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private allowZero!: boolean;

	private handleIncrement(): void {
		this.$emit('increment');
	}

	private handleDecrement(): void {
		this.$emit('decrement');
	}

	/**
	 * Update the value inside the input and emit the update to the parent component.
	 * Make sure only numbers are inputted, and limit to 3 digits.
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	private handleInput(event: Event): void {
		const input = event.target as HTMLInputElement;
		const value = input.value;

		const numericValue = value.replace(/\D/g, '');
		const limitedValue = numericValue.slice(0, 3);

		if (limitedValue !== value) {
			input.value = limitedValue;
		}
	}

	/**
	 * Ensure that the input is within the allowed limit.
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	private handleBlur(event: Event): void {
		const input = event.target as HTMLInputElement;
		const value = input.value.trim();
		let finalQuantity: number;

		if (value === '' || value === '0') {
			finalQuantity = this.allowZero ? 0 : 1;
		}
		else {
			finalQuantity = Number(value);
		}

		if (this.maxQuantity && finalQuantity > this.maxQuantity) {
			finalQuantity = this.maxQuantity;
		}
		this.$emit('update-quantity', finalQuantity);

		// In the end we set the input value to the final quantity calculated by the parent component
		// For example if the quantity typed by the user has to be limited by another quantity limit outside of this component's data
		this.$nextTick(() => {
			input.value = String(this.quantity > 0 ? this.quantity : 1);
		});
	}
}
